module.exports = __webpack_public_path__ + "img/Portfolio.bbfa74be.svg";